import { IEnum_Solution_Type, ITopicItemWithoutSubFragment } from 'src/graphql/generated/hooks'

export const getSolutionTypeFromTopic = (topic: ITopicItemWithoutSubFragment): IEnum_Solution_Type => {
  let solutionType: IEnum_Solution_Type = IEnum_Solution_Type.Product
  if (topic?.name === 'Alternative Legal Services') {
    solutionType = IEnum_Solution_Type.Alsp
  } else if (topic?.name === 'Consultants') {
    solutionType = IEnum_Solution_Type.Consultancy
  }
  return solutionType
}
